<template>
    <a-tabs v-model:activeKey="data.activeTab" centered>
        <a-tab-pane key="1">
            <template #tab>
                <span>
                    组件设置
                </span>
            </template>
            <template v-if="selectedWidget && selectedWidget.id">
                <div class="scrollBar" :style="{ height: '100%' }">
                    <template v-if="selectedWidget.category == 'container'">
                        <a-form layout="horizontal" :model="selectedWidget" :labelCol="{ style: { width: '120px' } }"
                            labelAlign="left">
                            <a-collapse v-model:activeKey="data.activeKey" :bordered="false" expandIconPosition="right"
                                style="background: #fff;">
                                <a-collapse-panel key="1" header="属性">
                                    <a-form-item label="唯一名称" name="name"
                                        :rules="[{ required: true, message: 'Please input name!' }]">
                                        <a-input v-model:value="selectedWidget.name" />
                                    </a-form-item>

                                    <!-- grid -->
                                    <template v-if="selectedWidget.type == 'grid'">
                                        <a-form-item label="栅格列高度(px)">
                                            <a-input v-model:value="selectedWidget.options.colHeight" />
                                        </a-form-item>
                                        <!-- <a-form-item label="gutter">
                                            <a-input v-model:value="selectedWidget.options.gutter" />
                                        </a-form-item> -->
                                        <div>栅格列</div>
                                        <div v-for="(item, index) in selectedWidget.widgetList" class="optionitem">
                                            <div style="flex-shrink: 0;">栅格宽度{{ index + 1 }}</div>
                                            <a-input-number v-model:value="item.options.span" style="margin:0 5px;" />
                                            <a-button shape="circle" @click="delCol(index)" danger>
                                                <template #icon>
                                                    del
                                                    <!-- <SearchOutlined /> -->
                                                </template>
                                            </a-button>
                                        </div>
                                        <div class="optionitem">
                                            <a-button type="link" @click="addCol">
                                                <template #icon>
                                                    <!-- <DownloadOutlined /> -->
                                                </template>
                                                添加栅格
                                            </a-button>
                                        </div>
                                    </template>

                                    <!-- grid-col -->
                                    <template v-if="selectedWidget.type == 'grid-col'">
                                        <a-form-item label="栅格宽度">
                                            <a-input-number v-model:value="selectedWidget.options.span" />
                                        </a-form-item>
                                        <a-form-item label="左侧间隔格数">
                                            <a-input-number v-model:value="selectedWidget.options.offset" />
                                        </a-form-item>
                                        <a-form-item label="左移栅格数">
                                            <a-input-number v-model:value="selectedWidget.options.pull" />
                                        </a-form-item>
                                        <a-form-item label="右移栅格数">
                                            <a-input-number v-model:value="selectedWidget.options.push" />
                                        </a-form-item>
                                    </template>
                                </a-collapse-panel>
                            </a-collapse>
                        </a-form>
                    </template>
                    <template v-else>
                        <a-form layout="horizontal" :model="selectedWidget" :labelCol="{ style: { width: '120px' } }"
                            labelAlign="left">
                            <a-collapse v-model:activeKey="data.activeKey" :bordered="false" expandIconPosition="right"
                                style="background: #fff;">
                                <a-collapse-panel key="1" header="属性">
                                    <a-form-item label="唯一名称" name="name"
                                        :rules="[{ required: true, message: 'Please input name!' }]">
                                        <a-input v-model:value="selectedWidget.name" @blur="updateInstanceList" />
                                    </a-form-item>
                                    <a-form-item label="标签">
                                        <a-input v-model:value="selectedWidget.label" />
                                    </a-form-item>

                                    <!-- 表单项属性 -->
                                    <template v-if="selectedWidget.type != 'button'">
                                        <a-form-item label="标签对齐">
                                            <a-radio-group v-model:value="selectedWidget.labelAlign">
                                                <a-radio-button value="left">left</a-radio-button>
                                                <a-radio-button value="right">right</a-radio-button>
                                            </a-radio-group>
                                        </a-form-item>
                                        <a-form-item label="标签宽度">
                                            <a-input-number v-model:value="selectedWidget.labelWidth" />
                                        </a-form-item>
                                        <a-form-item label="必填">
                                            <a-switch v-model:checked="selectedWidget.options.required" />
                                        </a-form-item>
                                        <a-form-item label="必填校验提示">
                                            <a-input v-model:value="selectedWidget.options.requiredHint" />
                                        </a-form-item>
                                        <a-form-item label="正则">
                                            <a-select v-model:value="selectedWidget.options.validation"
                                                :options="data.validoptions" :allowClear="true"></a-select>
                                        </a-form-item>
                                        <a-form-item label="正则校验提示">
                                            <a-input v-model:value="selectedWidget.options.validationHint" />
                                        </a-form-item>
                                    </template>

                                    <!-- 默认值 -->
                                    <template v-if="isText">
                                        <a-form-item label="默认值">
                                            <a-input v-model:value="selectedWidget.options.defaultValue" />
                                        </a-form-item>
                                    </template>

                                    <!-- 输入值 -->
                                    <template v-if="isCommon || isTime || isDate">
                                        <template v-if="isRange">
                                            <a-form-item label="开始占位内容">
                                                <a-input v-model:value="selectedWidget.options.startPlaceholder" />
                                            </a-form-item>
                                            <a-form-item label="结尾占位内容">
                                                <a-input v-model:value="selectedWidget.options.endPlaceholder" />
                                            </a-form-item>
                                        </template>
                                        <template v-else>
                                            <a-form-item label="占位内容">
                                                <a-input v-model:value="selectedWidget.options.placeholder" />
                                            </a-form-item>
                                        </template>
                                    </template>

                                    <!-- 可清除 -->
                                    <template v-if="isClear || isTime || isDate">
                                        <a-form-item label="可清除">
                                            <a-switch v-model:checked="selectedWidget.options.allowClear" />
                                        </a-form-item>
                                    </template>

                                    <!-- 禁用 -->
                                    <a-form-item label="禁用">
                                        <a-switch v-model:checked="selectedWidget.options.disabled" />
                                    </a-form-item>

                                    <!-- 文本值 -->
                                    <template v-if="isText">
                                        <a-form-item label="最大长度">
                                            <a-input v-model:value="selectedWidget.options.maxLength" />
                                        </a-form-item>
                                    </template>

                                    <!-- textarea -->
                                    <template v-if="selectedWidget.type == 'textarea' || selectedWidget.type == 'speak'">
                                        <a-form-item label="显示字数">
                                            <a-switch v-model:checked="selectedWidget.options.showCount" />
                                        </a-form-item>
                                        <a-form-item label="自动高度">
                                            <a-switch v-model:checked="selectedWidget.options.autosize" />
                                        </a-form-item>
                                    </template>

                                    <!-- speak -->
                                    <template v-if="selectedWidget.type == 'speak'">
                                        <a-form-item label="播放次数">
                                            <a-input v-model:value="selectedWidget.options.times" />
                                        </a-form-item>
                                    </template>

                                    <!-- number -->
                                    <template v-if="selectedWidget.type == 'number'">
                                        <a-form-item label="最小值">
                                            <a-input v-model:value="selectedWidget.options.min" />
                                        </a-form-item>
                                        <a-form-item label="最大值">
                                            <a-input v-model:value="selectedWidget.options.max" />
                                        </a-form-item>
                                        <a-form-item label="步数">
                                            <a-input v-model:value="selectedWidget.options.step" />
                                        </a-form-item>
                                        <a-form-item label="精度">
                                            <a-input v-model:value="selectedWidget.options.precision" />
                                        </a-form-item>
                                        <a-form-item label="prefixIcon">
                                            <a-input v-model:value="selectedWidget.options.prefixIcon" />
                                        </a-form-item>
                                    </template>

                                    <!-- icon -->
                                    <template v-if="isInput">
                                        <a-form-item label="prefixIcon">
                                            <a-input v-model:value="selectedWidget.options.prefixIcon" />
                                        </a-form-item>
                                        <a-form-item label="suffixIcon">
                                            <a-input v-model:value="selectedWidget.options.suffixIcon" />
                                        </a-form-item>
                                    </template>

                                    <!-- radio -->
                                    <template v-if="selectedWidget.type == 'radio'">
                                        <a-form-item label="显示类型">
                                            <a-radio-group v-model:value="selectedWidget.options.optionType">
                                                <a-radio-button value="default">default</a-radio-button>
                                                <a-radio-button value="button">button</a-radio-button>
                                            </a-radio-group>
                                        </a-form-item>
                                        <a-form-item label="按钮样式">
                                            <a-radio-group v-model:value="selectedWidget.options.buttonStyle">
                                                <a-radio-button value="outline">outline</a-radio-button>
                                                <a-radio-button value="solid">solid</a-radio-button>
                                            </a-radio-group>
                                        </a-form-item>
                                    </template>

                                    <!-- password -->
                                    <template v-if="selectedWidget.type == 'password'">
                                        <!-- <a-form-item label="showCount">
                                            <a-switch v-model:checked="selectedWidget.options.showCount" />
                                        </a-form-item> -->
                                    </template>

                                    <!-- switch -->
                                    <template v-if="selectedWidget.type == 'switch'">
                                        <a-form-item label="默认值">
                                            <a-switch v-model:checked="data.initValue[selectedWidget.name]"
                                                @change="setInitValue" />
                                        </a-form-item>
                                    </template>

                                    <!-- select -->
                                    <template v-if="selectedWidget.type == 'select'">
                                        <a-form-item label="模式">
                                            <a-select v-model:value="selectedWidget.options.mode" :options="[{
                                                    value: 'combobox',
                                                    label: 'combobox',
                                                }, {
                                                    value: 'tags',
                                                    label: 'tags',
                                                }, {
                                                    value: 'multiple',
                                                    label: 'multiple',
                                                }]"></a-select>
                                        </a-form-item>
                                        <a-form-item label="自定义节点字段">
                                            <code-editor
                                                :bindCode="{ title: 'fieldNames', code: selectedWidget.options.fieldNames, mode: 'json' }"
                                                @handleOk="setCode"></code-editor>
                                        </a-form-item>
                                        <a-form-item label="数据查询方法">
                                            <code-editor
                                                :bindCode="{ title: 'queryFunction', code: selectedWidget.options.queryFunction, mode: 'json' }"
                                                @handleOk="setCode"></code-editor>
                                        </a-form-item>
                                        <a-form-item label="可搜索">
                                            <a-switch v-model:checked="selectedWidget.options.showSearch" />
                                        </a-form-item>
                                        <!-- <a-form-item label="isRemote">
                                            <a-switch v-model:checked="selectedWidget.options.isRemote" />
                                        </a-form-item> -->
                                        <a-form-item label="label包装到value">
                                            <a-switch v-model:checked="selectedWidget.options.labelInValue" />
                                        </a-form-item>
                                        <a-form-item label="无数据占位内容">
                                            <a-input v-model:value="selectedWidget.options.notFoundContent" />
                                        </a-form-item>
                                        <a-form-item label="搜索时过滤属性">
                                            <a-input v-model:value="selectedWidget.options.optionFilterProp" />
                                        </a-form-item>
                                        <a-form-item label="最多显示tag数量">
                                            <a-input-number v-model:value="selectedWidget.options.maxTagCount" />
                                        </a-form-item>
                                        <a-form-item label="最大显示tag长度">
                                            <a-input-number v-model:value="selectedWidget.options.maxTagTextLength" />
                                        </a-form-item>
                                    </template>

                                    <!-- upload -->
                                    <template v-if="selectedWidget.type == 'upload'">
                                        <a-form-item label="文件类型">
                                            <a-input v-model:value="selectedWidget.options.accept" />
                                        </a-form-item>
                                        <a-form-item label="上传地址">
                                            <a-input v-model:value="selectedWidget.options.action" />
                                        </a-form-item>
                                        <a-form-item label="添加水印">
                                            <a-switch v-model:checked="selectedWidget.options.waterRemark" />
                                        </a-form-item>
                                        <a-form-item label="可多选">
                                            <a-switch v-model:checked="selectedWidget.options.multiple" />
                                        </a-form-item>
                                        <a-form-item label="支持上传文件夹">
                                            <a-switch v-model:checked="selectedWidget.options.directory" />
                                        </a-form-item>
                                        <a-form-item label="展示上传列表">
                                            <a-switch v-model:checked="selectedWidget.options.showUploadList" />
                                        </a-form-item>
                                        <a-form-item label="最大上传数量">
                                            <a-input-number v-model:value="selectedWidget.options.maxCount" />
                                        </a-form-item>
                                        <a-form-item label="文件大小限制(MB)">
                                            <a-input-number v-model:value="selectedWidget.options.maxFileSize" />
                                        </a-form-item>
                                    </template>

                                    <template v-if="selectedWidget.type == 'rich-editor'">
                                        <a-form-item label="上传方法">
                                            <code-editor
                                                :bindCode="{ title: 'uploadFunction', code: selectedWidget.options.uploadFunction, mode: 'json' }"
                                                @handleOk="setCode"></code-editor>
                                        </a-form-item>
                                        <a-form-item label="默认值">
                                            <a-input v-model:value="selectedWidget.options.defaultValue" />
                                        </a-form-item>
                                        <a-form-item label="编辑器高度">
                                            <a-input-number v-model:value="selectedWidget.options.initialFrameHeight" />
                                        </a-form-item>
                                        <a-form-item label="最大字数限制">
                                            <a-input-number v-model:value="selectedWidget.options.maximumWords" />
                                        </a-form-item>
                                    </template>

                                    <template v-if="isDate || isTime">
                                        <a-form-item label="只读">
                                            <a-switch v-model:checked="selectedWidget.options.inputReadOnly" />
                                        </a-form-item>
                                        <a-form-item label="格式">
                                            <a-input v-model:value="selectedWidget.options.format" />
                                        </a-form-item>
                                    </template>

                                    <!-- isDate -->
                                    <template v-if="isDate">
                                        <a-form-item label="选择器">
                                            <a-select v-model:value="selectedWidget.options.picker" :options="[{
                                                    value: 'date',
                                                    label: 'date',
                                                }, {
                                                    value: 'month',
                                                    label: 'month',
                                                }, {
                                                    value: 'year',
                                                    label: 'year',
                                                }]" :allowClear="true"></a-select>
                                        </a-form-item>
                                        <a-form-item label="时间格式">
                                            <a-select v-model:value="selectedWidget.options.showTime" :options="[{
                                                    value: 'hh:mm:ss',
                                                    label: 'hh:mm:ss',
                                                }, {
                                                    value: 'hh:mm',
                                                    label: 'hh:mm',
                                                }, {
                                                    value: 'hh',
                                                    label: 'hh',
                                                }]" :allowClear="true"></a-select>
                                        </a-form-item>
                                        <!-- <a-form-item label="disabledDate">
                                            <a-input v-model:value="selectedWidget.options.disabledDate" />
                                        </a-form-item>
                                        <a-form-item label="disabledTime">
                                            <a-input v-model:value="selectedWidget.options.disabledTime" />
                                        </a-form-item> -->
                                    </template>

                                    <!-- isTime -->
                                    <template v-if="isTime">
                                        <!-- <a-form-item label="disabledHours">
                                            <a-input v-model:value="selectedWidget.options.disabledHours" />
                                        </a-form-item>
                                        <a-form-item label="disabledMinutes">
                                            <a-input v-model:value="selectedWidget.options.disabledMinutes" />
                                        </a-form-item>
                                        <a-form-item label="disabledSeconds">
                                            <a-input v-model:value="selectedWidget.options.disabledSeconds" />
                                        </a-form-item> -->
                                    </template>

                                    <!-- button -->
                                    <template v-if="selectedWidget.type == 'button'">
                                        <a-form-item label="类型">
                                            <a-select v-model:value="selectedWidget.options.type"
                                                :options="data.btnoptions"></a-select>
                                        </a-form-item>
                                        <a-form-item label="占满父元素">
                                            <a-switch v-model:checked="selectedWidget.options.block" />
                                        </a-form-item>
                                        <a-form-item label="危险">
                                            <a-switch v-model:checked="selectedWidget.options.danger" />
                                        </a-form-item>
                                        <a-form-item label="形状">
                                            <a-radio-group v-model:value="selectedWidget.options.shape" size="small">
                                                <a-radio-button value="default">default</a-radio-button>
                                                <a-radio-button value="circle">circle</a-radio-button>
                                                <a-radio-button value="round">round</a-radio-button>
                                            </a-radio-group>
                                        </a-form-item>
                                        <a-form-item label="icon">
                                            <a-input v-model:value="selectedWidget.options.icon" />
                                        </a-form-item>
                                    </template>

                                    <!-- optionItems -->
                                    <template
                                        v-if="selectedWidget.type == 'radio' || selectedWidget.type == 'checkbox' || selectedWidget.type == 'select'">
                                        <div>选项</div>
                                        <a-radio-group v-model:value="data.initValue[selectedWidget.name]"
                                            @change="setInitValue"
                                            v-if="selectedWidget.type == 'radio' || (selectedWidget.type == 'select' && selectedWidget.options.mode == 'combobox')">
                                            <div v-for="(item, index) in selectedWidget.options.optionItems"
                                                class="optionitem">
                                                <a-radio :value="item.value"></a-radio>
                                                <a-input v-model:value="item.value" />
                                                <a-input v-model:value="item.label" />
                                                <a-button shape="circle" style="margin-left: 5px;" @click="delItem(index)"
                                                    danger>
                                                    <template #icon>
                                                        del
                                                        <!-- <SearchOutlined /> -->
                                                    </template>
                                                </a-button>
                                            </div>
                                        </a-radio-group>

                                        <a-checkbox-group v-model:value="data.initValue[selectedWidget.name]"
                                            @change="setInitValue"
                                            v-if="selectedWidget.type == 'checkbox' || (selectedWidget.type == 'select' && selectedWidget.options.mode != 'combobox')">
                                            <div v-for="(item, index) in selectedWidget.options.optionItems"
                                                class="optionitem">
                                                <a-checkbox :value="item.value" style="margin-right: 5px;"></a-checkbox>
                                                <a-input v-model:value="item.value" />
                                                <a-input v-model:value="item.label" />
                                                <a-button shape="circle" style="margin-left: 5px;" @click="delItem(index)"
                                                    danger>
                                                    <template #icon>
                                                        del
                                                        <!-- <SearchOutlined /> -->
                                                    </template>
                                                </a-button>
                                            </div>
                                        </a-checkbox-group>
                                        <div class="optionitem">
                                            <a-button type="link" @click="addItem">
                                                <template #icon>
                                                    <!-- <DownloadOutlined /> -->
                                                </template>
                                                添加选项
                                            </a-button>
                                            <a-button type="link" @click="clearValue">
                                                <template #icon>
                                                    <!-- <DownloadOutlined /> -->
                                                </template>
                                                清空选中项
                                            </a-button>
                                        </div>
                                    </template>

                                </a-collapse-panel>
                                <a-collapse-panel key="2" header="方法">
                                    <a-form-item label="onMounted">
                                        <code-editor
                                            :bindCode="{ title: 'onMounted', code: selectedWidget.options.onMounted, mode: 'javascript' }"
                                            @handleOk="setCode"></code-editor>
                                    </a-form-item>
                                    <template
                                        v-if="selectedWidget.type != 'button' && selectedWidget.type != 'textarea' && selectedWidget.type != 'speak'">
                                        <a-form-item label="onChange">
                                            <code-editor
                                                :bindCode="{ title: 'onChange', code: selectedWidget.options.onChange, mode: 'javascript' }"
                                                @handleOk="setCode"></code-editor>
                                        </a-form-item>
                                    </template>
                                    <template v-if="isText">
                                        <a-form-item label="onPressEnter">
                                            <code-editor
                                                :bindCode="{ title: 'onPressEnter', code: selectedWidget.options.onPressEnter, mode: 'javascript' }"
                                                @handleOk="setCode"></code-editor>
                                        </a-form-item>
                                    </template>
                                    <template v-if="selectedWidget.type == 'button'">
                                        <a-form-item label="onClick">
                                            <code-editor
                                                :bindCode="{ title: 'onClick', code: selectedWidget.options.onClick, mode: 'javascript' }"
                                                @handleOk="setCode"></code-editor>
                                        </a-form-item>
                                    </template>
                                    <!-- <template v-if="selectedWidget.type == 'select'">
                                        <a-form-item label="onRemoteQuery">
                                            <code-editor
                                                :bindCode="{ title: 'onRemoteQuery', code: selectedWidget.options.onRemoteQuery, mode: 'javascript'  }"
                                                @handleOk="setCode"></code-editor>
                                        </a-form-item>
                                    </template> -->
                                </a-collapse-panel>

                            </a-collapse>
                        </a-form>
                    </template>
                </div>
            </template>
        </a-tab-pane>
        <a-tab-pane key="2">
            <template #tab>
                <span>
                    表单设置
                </span>
            </template>
            <a-form layout="horizontal" :model="formConfig" :labelCol="{ style: { width: '120px' } }" labelAlign="left">
                <a-collapse v-model:activeKey="data.activeKey" :bordered="false" expandIconPosition="right"
                    style="background: #fff;">
                    <a-collapse-panel key="1" header="属性">
                        <a-form-item label="labelAlign">
                            <a-radio-group v-model:value="formConfig.labelAlign">
                                <a-radio-button value="left">left</a-radio-button>
                                <a-radio-button value="right">right</a-radio-button>
                            </a-radio-group>
                        </a-form-item>
                        <a-form-item label="labelWidth">
                            <a-input-number v-model:value="formConfig.labelWidth" />
                        </a-form-item>
                    </a-collapse-panel>
                    <!-- <a-collapse-panel key="2" header="方法">
                        <a-form-item label="onFormMounted">
                            <code-editor
                                :bindCode="{ title: 'onFormMounted', code: formConfig.onFormMounted, mode: 'javascript' }"
                                @handleOk="setFormCode"></code-editor>
                        </a-form-item>
                    </a-collapse-panel> -->
                </a-collapse>
            </a-form>
        </a-tab-pane>
    </a-tabs>
</template>

<script setup>
import { onMounted, toRefs, computed, inject, reactive } from 'vue';
import { containers } from "../widget-panel/config";
import { deepClone, generateId, getContainerByType } from "../../tools";
import CodeEditor from "../../btn-edit/btn-edit.vue";
import http from "@/request/request";
import { message } from 'ant-design-vue';

const data = reactive({
    activeTab: '1',
    activeKey: ['1', '2'],
    initValue: {},
    btnoptions: [{
        value: 'primary',
        label: 'primary',
    }, {
        value: 'ghost',
        label: 'ghost',
    }, {
        value: 'dashed',
        label: 'dashed',
    }, {
        value: 'link',
        label: 'link',
    }, {
        value: 'text',
        label: 'text',
    }, {
        value: 'default',
        label: 'default',
    }],
    validoptions: [{
        value: 'number',
        label: 'number',
    }, {
        value: 'letter',
        label: 'letter',
    }, {
        value: 'letterAndNumber',
        label: 'letterAndNumber',
    }, {
        value: 'mobilePhone',
        label: 'mobilePhone',
    }, {
        value: 'letterStartNumberIncluded',
        label: 'letterStartNumberIncluded',
    }, {
        value: 'noChinese',
        label: 'noChinese',
    }, {
        value: 'chinese',
        label: 'chinese',
    }, {
        value: 'email',
        label: 'email',
    }, {
        value: 'url',
        label: 'url',
    }],
    formModels: []
})


const props = defineProps({
    modelFunction: Object,
})
const { modelFunction } = toRefs(props)
const emits = defineEmits(["editName"]);
const { getSelectWidget, getFormConfig } = inject("designer")

const selectedWidget = computed(() => getSelectWidget())
const formConfig = computed(() => getFormConfig())
const isCommon = computed(() => {
    const arr = ['input', 'select', 'textarea', 'speak', 'password', 'number']
    return arr.indexOf(selectedWidget.value.type) != -1
})
const isRange = computed(() => {
    const arr = ['time-range', 'date-range']
    return arr.indexOf(selectedWidget.value.type) != -1
})
const isInput = computed(() => {
    const arr = ['input', 'password']
    return arr.indexOf(selectedWidget.value.type) != -1
})
const isClear = computed(() => {
    const arr = ['input', 'password', 'select', 'textarea', 'speak']
    return arr.indexOf(selectedWidget.value.type) != -1
})
const isText = computed(() => {
    const arr = ['input', 'textarea', 'speak', 'password', 'number']
    return arr.indexOf(selectedWidget.value.type) != -1
})
const isTime = computed(() => {
    const arr = ['time', 'time-range']
    return arr.indexOf(selectedWidget.value.type) != -1
})
const isDate = computed(() => {
    const arr = ['date', 'date-range']
    return arr.indexOf(selectedWidget.value.type) != -1
})

const updateInstanceList = (e) => {
    emits('editName', e.target.value)
}

const addCol = () => {
    let newCol = deepClone(getContainerByType(containers, 'grid-col'))
    let tmpId = generateId()
    newCol.id = 'grid-col-' + tmpId
    newCol.name = 'gridCol' + tmpId
    selectedWidget.value.widgetList.push(newCol)
}

const delCol = (i) => {
    selectedWidget.value.widgetList.splice(i, 1)
}

const setInitValue = () => {
    selectedWidget.value.options.defaultValue = data.initValue[selectedWidget.value.name]
}

const addItem = () => {
    selectedWidget.value.options.optionItems.push({ value: selectedWidget.value.options.optionItems.length + 1, label: 'new option' })
}

const delItem = (i) => {
    selectedWidget.value.options.optionItems.splice(i, 1)
}

const clearValue = () => {
    data.initValue[selectedWidget.value.name] = null
    selectedWidget.value.options.defaultValue = null
}

const setCode = (val) => {
    selectedWidget.value.options[val.title] = val.code
}

const setFormCode = (val) => {
    formConfig.value[val.title] = val.code
}

const loadModels = () => {
    const modelApi = modelFunction.value
    if (!!modelApi && !!modelApi.path) {
        const config = {
            url: modelApi.path,
            method: modelApi.method || "get",
            [modelApi.method == 'post' ? 'data' : 'params']: modelApi.params,
        }
        http.request(config).then(res => {
            if (res.data.code == 200) {
                data.formModels = res.data.rows;
                console.log("success");
            } else if (res.data.msg) {
                message.error(res.data.msg);
            }
        }).catch(err => message.error("请求失败", err))
    }
}

onMounted(() => loadModels())
</script>

<style lang="scss" scoped>
.ant-tabs {
    height: 100%;
}

::v-deep .ant-tabs-content {
    height: 100%;
}

::v-deep .ant-tabs-nav {
    margin: 0;
}

.ant-form-item {
    margin: 0 0 8px;
}

.optionitem {
    display: flex;
    align-items: center;
    margin: 5px 0;
}
</style>